import Vue from 'vue'
import Vuex from 'vuex'
import * as getters from './getters'
import * as actions from './actions'
import navLinks from './modules/navLinks'

const debug = process.env.NODE_ENV !== 'production'

Vue.use(Vuex)

export default new Vuex.Store({
  actions,
  getters,
  modules: {
    navLinks
  },
  strict: debug
})



// WEBPACK FOOTER //
// ./src/store/index.js